import type { GameModuleProps } from '../types/game';
import { ContentActions } from '../components/ContentActions';

export function StoryModule({ module, onComplete }: GameModuleProps<'story'>) {
  return (
    <article className="module-content story-module">
      {module.config.image && <img className="story-image" src={module.config.image} alt={module.config.imageAlt || ''} style={{ objectFit: module.config.imageFit || 'contain', objectPosition: module.config.imagePosition || 'center', maxHeight: module.config.imageHeight ? `${module.config.imageHeight}px` : undefined }} />}
      {module.config.video && <video className="story-video" controls autoPlay={module.config.videoAutoplay} loop={module.config.videoLoop} muted={module.config.videoMuted ?? module.config.videoAutoplay} playsInline poster={module.config.videoPoster}><source src={module.config.video} /></video>}
      <p className="story-copy">{module.config.text}</p>
      <ContentActions modalTitle={module.config.modalTitle} modalContent={module.config.modalContent} attachments={module.config.attachments} />
      <button className="button button-primary" onClick={() => onComplete({ success: true, attempts: 1 })}>
        {module.config.buttonLabel || 'Continuar'}
      </button>
    </article>
  );
}
